import { render, staticRenderFns } from "./OfferElement.vue?vue&type=template&id=07924516"
import script from "./OfferElement.vue?vue&type=script&lang=js"
export * from "./OfferElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports